import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/")({
  validateSearch: (s: Record<string, unknown>) => ({
    a: typeof s.a === "string" ? s.a : undefined,
  }),
  component: IndexRedirect,
});

function IndexRedirect() {
  const navigate = useNavigate();
  const { a } = Route.useSearch();

  useEffect(() => {
    if (a) {
      navigate({
        to: "/test/$assignmentId",
        params: { assignmentId: a },
        replace: true,
      });
    } else {
      navigate({ to: "/invitations", replace: true });
    }
  }, [a, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
    </div>
  );
}
